export const providerConstants = {
    GET_PROVIDERS_REQUEST: 'GET_PROVIDERS_REQUEST',
    GET_PROVIDERS_SUCCESS: 'GET_PROVIDERS_SUCCESS',
    GET_PROVIDERS_FAILURE: 'GET_PROVIDERS_FAILURE'
};
